import React from 'react'
import styles from '../../UserCard.module.scss'

const VideosResumeItem = ({ videoUrl }) => {
  return (
    <div className={styles.videoResumeFrame}>
      <video controls playsInline className={styles.videoResume}>
        {videoUrl.length ? (
          videoUrl.map(({ id, file, file_name }) => (
            <source key={id} src={file} type={`video/${file_name.split('.')[1]}`} />
          ))
        ) : (
          <source key={videoUrl.id} src={videoUrl.file} type={`video/${videoUrl.file_name.split('.')[1]}`} />
        )}
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

export default VideosResumeItem
